import { formatIncompletePhoneNumber, formatComplete } from "libphonenumber-js";

export const formatPhoneNumber = (value) => {
  if (value) {
    return formatIncompletePhoneNumber(value, "US");
  }

  return "";
};
